export default {
    FormImportStudent: require('./FormImportStudent').default,
}